// import React from 'react';
// import FeatureCard from '../../../../styles/FeatureCard.js';

// import agent from '../../../../assets/services/disaster/allinonebackups1.svg';
// import AP from '../../../../assets/services/disaster/nodisasterrecovery1.svg';
// import HW from '../../../../assets/services/disaster/disasterrecoveryforworlkoads1.svg';
// import self from '../../../../assets/services/disaster/offsitefailover1.svg';
// import efficientStorage from '../../../../assets/services/disaster/seamless1.svg';
// import WO from '../../../../assets/services/disaster/disasterrecoveryrunbooks1.svg';
// import EA from '../../../../assets/services/disaster/automatedtesting1.svg';
// import support from '../../../../assets/services/disaster/support1.svg';

// const Cards = () => {
//   return (
//     <div className="disastercards disastercards-padding my-0 my-md-4">
//       <div className="disastercards-row">
//         <FeatureCard
//           image={agent}
//           title="All-in-one Backup, Disaster Recovery and Protection Services"
//           description={
//             <>
//               As a business you need a cloud backup provider that offers strong security, including encryption, where Synectiks offers all in one solution including high speed disaster recovery.
//               <br />
//               Protect your workloads when disaster strikes, by instantly spinning up systems in our Disaster Recovery Cloud. Adding this service ensures the data is immediately available - and with Synectiks, it's as easy as flipping a switch providing END to END Encryption, In-Flight and Data-At-Rest Encryption, AI-based Ransomware protection.
//             </>
//           }
//         />
//         <FeatureCard image={AP} title="Meet Compliance with minimum complexity" description="Sometimes “where” data is matters. Configure your client DR solutions to deploy to the physical location that delivers the most value in the cloud or the datacenter next door. No need to add, learn, or manage multiple platforms. It’s one solution for all workloads and use cases managed from a single interface that enables you to build a complete DRaaS " />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard image={HW} title="Disaster recovery for physical and virtual workloads" description="Minimize downtime by enabling easy, scalable and efficient cloud-based recovery of all popular workloads including Windows and Linux physical servers and VMs, major hypervisors, and Microsoft apps." />
//         <FeatureCard image={self} title="Production and Automated test failover" description="Ensure quick and easily automated failover of the client’s production environment to an offsite server running in the Acronis Disaster Recovery Storage or to a hot storage in the Cloud. Achieve both RPOs and RTOs shorter than 15 minutes. Save time and effort with a simplified, automated test failover. With the Disaster Recovery service, you can perform scheduled test failovers for any server monthly, giving you the confidence that you can recover quickly and successfully. " />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard image={efficientStorage} title="No-Disaster Recovery Cloud Compute Reservation Cost" description="Pay only when you use the compute resources in the disaster recovery cloud, billed in hourly increments. Pay-as-you-go: pay for used DR cloud storage and for compute only during recovery or tests." />
//         <FeatureCard image={WO} title="Disaster recovery orchestration with runbooks" description="DR orchestration automates and manages disaster recovery processes, using runbooks to define the sequence for spinning up servers, applications, and networks in a cloud recovery site after a failure, ensuring systems come online in the correct order for business continuity, minimizing downtime with fast failover, and allowing non-disruptive testing. It integrates with backups offering flexibility and rapid recovery for complex IT setups. " />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard image={EA} title="Critical data disaster recovery modes" description="Cloud disaster recovery is the most cost-effective and scalable option. Cloud disaster recovery allows you to keep entire virtual environments at the ready, reducing recovery from a disaster or business outage to minutes or even seconds.
// A hybrid cloud disaster recovery method uses a public cloud and private data center (physical or cloud). This provides a great degree of flexibility, keeps costs down, while also meeting any regulatory and compliance needs.
// " />
//         <FeatureCard image={support} title="Support" description="Our team is certified to protect business continuity across your hosted cloud environment—whether it is a mission-critical server, a virtual machine, or an endpoint device. We design and operate cloud backup and disaster recovery plans with multiple recovery options (backup, replication, and rapid restore), supported by built-in cyber protection to reduce the risk of ransomware and data loss. From readiness checks and runbooks to recovery testing and incident support, we ensure your systems can be restored quickly and safely when an outage or disaster occurs." />
//       </div>

//     </div>
//   );
// };

// export default Cards;






import React from 'react';
// import FeatureCard from './FeatureCard'; // Ensure path is correct
import '../../../../styles/disasterCard.css'; // Ensure CSS is imported
import FeatureCard from '../../../../styles/FeatureCard.js';

// Import your images...
import agent from '../../../../assets/services/disaster/allinonebackups1.svg';
import AP from '../../../../assets/services/disaster/nodisasterrecovery1.svg';
import HW from '../../../../assets/services/disaster/disasterrecoveryforworlkoads1.svg';
import self from '../../../../assets/services/disaster/offsitefailover1.svg';
import efficientStorage from '../../../../assets/services/disaster/seamless1.svg';
import WO from '../../../../assets/services/disaster/disasterrecoveryrunbooks1.svg';
import EA from '../../../../assets/services/disaster/automatedtesting1.svg';
import support from '../../../../assets/services/disaster/support1.svg';
import GeoDistributed from '../../../../assets/services/disaster/GeoDistributed.svg';

const Cards = () => {
  const cardData = [
    {
      image: agent,
      title: "All-in-one Backup, Disaster Recovery, and Protection Services",
      description: (
        <>
          <p>
            As a business, you need a cloud backup provider that offers strong security, including encryption. Synectiks offers an all-in-one solution including high-speed disaster recovery.
          </p>
          <p>
            Protect your workloads when disaster strikes by instantly spinning up systems in our Disaster Recovery Cloud. With Synectiks, it's as easy as flipping a switch, providing <strong>END-to-END Encryption</strong>, In-Flight and Data-At-Rest Encryption, and AI-based Ransomware protection.
          </p>
        </>
      )
    },
    {
      image: AP,
      title: "Meet Compliance with minimum complexity",
      description: (
        <>
          <p>
            Sometimes “where” data is matters. Configure your client DR solutions to deploy to the physical location that delivers the most value-in the cloud or the datacenter next door.
          </p>
          <p>
            No need to add, learn, or manage multiple platforms. It’s one solution for all workloads and use cases managed from a single interface that enables you to build a complete DRaaS solution.
          </p>
        </>
      )
    },
    {
      image: HW,
      title: "Disaster recovery for physical and virtual workloads",
      description: (
        <p>
          Minimize downtime by enabling easy, scalable, and efficient cloud-based recovery of all popular workloads including Windows and Linux physical servers and VMs, major hypervisors, and Microsoft apps.
        </p>
      )
    },
    {
      image: self,
      title: "Production and Automated test failover",
      description: (
        <>
          <p>
            Ensure quick and easily automated failover of the client’s production environment to an offsite server running in the Acronis Disaster Recovery Storage or to hot storage in the Cloud. Achieve both RPOs and RTOs shorter than 15 minutes.
          </p>
          <p>
            Save time and effort with a simplified, automated test failover. With the Disaster Recovery service, you can perform scheduled test failovers, giving you the confidence.
          </p>
        </>
      )
    },
    {
      image: efficientStorage,
      title: "No-Disaster Recovery Cloud Compute Reservation Cost",
      description: (
        <p>
          Pay only when you use the compute resources in the disaster recovery cloud, billed in hourly increments. Pay-as-you-go: pay for used DR cloud storage and for compute only during recovery or tests.
        </p>
      )
    },
    {
      image: WO,
      title: "Disaster recovery orchestration with runbooks",
      description: (
        <p>
          DR orchestration automates and manages disaster recovery processes, using runbooks to define the sequence for spinning up servers, applications, and networks in a cloud recovery site after a failure. This ensures systems come online in the correct order for business continuity, minimizing downtime with fast failover, and allowing non-disruptive testing. It integrates with backups, offering flexibility and rapid recovery for complex IT setups.
        </p>
      )
    },
    {
      image: EA,
      title: "Critical data disaster recovery modes",
      description: (
        <>
          <p>
            Cloud disaster recovery is the most cost-effective and scalable option. Cloud disaster recovery allows you to keep entire virtual environments at the ready, reducing recovery from a disaster or business outage to minutes or even seconds.
          </p>
          <p>
            A hybrid cloud disaster recovery method uses a public cloud and private data center (physical or cloud). This provides a great degree of flexibility and keeps costs down, while also meeting any regulatory and compliance needs.
          </p>
        </>
      )
    },

    {
      image: GeoDistributed,
      title: "Geo-Distributed Disaster Recovery Sites",
      description: (
        <p>
          With Synectiks DR, you can fail over critical workloads to a ready-made recovery site in the cloud by strictly adhering to the industry-leading 3-2-1-1 Rule. The DR environment runs in global data centers, supports flexible connectivity, and lets you run scheduled test failovers to prove recovery readiness without disturbing production. For resilience and compliance, you can choose the DR site location based on data sovereignty, latency, and business requirements. The DR data centers are designed for high availability with redundant infrastructure, strict physical access controls, and backup power (UPS and generators) to keep services running during power disruptions.
        </p>
      )
    },
    {
      image: support,
      title: "Support",
      description: (
        <p>
          At Synectiks, our certified engineers don't just manage backups. We guarantee business continuity. Whether you are protecting mission-critical servers, cloud-native VMs, or remote endpoints, our team provides an end-to-end safety net. By integrating high-frequency replication and rapid-restoring capabilities with built-in AI cyber protection, we neutralize ransomware threats and eliminate the risk of data loss. From the initial readiness audit and runbook development to automated recovery testing and 24/7 incident response, we ensure your organization can rebound from any disaster - quickly, safely, and with zero data gaps.
        </p>
      )
    },
  ];

  return (
    <div className="disastercards-section">
      <div className="disastercards-grid">
        {cardData.map((card, index) => (
          <FeatureCard
            key={index}
            image={card.image}
            title={card.title}
            description={card.description}
            centered={true} // Forces Center Alignment
          />
        ))}
      </div>
    </div>
  );
};

export default Cards;
